import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AvailabilityCode } from '../../../../../_models/admin/supplier-interface/availability.code';
import { SupplierResponse } from '../../../../../_models/admin/supplier-interface/supplier.response';
import { SupplierResponseItem } from '../../../../../_models/admin/supplier-interface/supplier.response.item';
import { SupplierResponseItemDepot } from '../../../../../_models/admin/supplier-interface/supplier.response.item.depot';
import { SupplierResponseItemExtraFeeKind } from '../../../../../_models/admin/supplier-interface/supplier.response.item.extra.fee.kind';

@Component({
  selector: 'app-supplier-interface-response',
  templateUrl: './supplier-interface-response.component.html',
  styleUrls: ['./supplier-interface-response.component.scss']
})
export class SupplierInterfaceResponseComponent implements OnInit {
  availabilityCode = AvailabilityCode;
  extraFeeKind = SupplierResponseItemExtraFeeKind;
  @Input() response: SupplierResponse;
  @Output() searchAction: EventEmitter<string> = new EventEmitter();
  @Input() withoutFirstColumn = false;
  odd = false;

  constructor() { }

  ngOnInit(): void {
  }

  noItems(): boolean {
    if (this.response && this.response.Items && Object.keys(this.response.Items).length > 0) return false;
    return true
  }

  isOdd(): boolean {
    this.odd = !this.odd;
    return this.odd;
  }

  getProperties(item: SupplierResponseItem): string[] {
    if (item.Properties) {
      const properties = Object.keys(item.Properties);
      return properties.filter(p => p != 'SupplierId');
    }
    return null;
  }

  getExtraData(item: SupplierResponseItem): string[] {
    if (item.ExtraData) {
      const data = Object.keys(item.ExtraData);
      return data;
    }
    return null;
  }

  getFirstDepot(item: SupplierResponseItem): SupplierResponseItemDepot {
    if (item?.Depots?.length) return item.Depots[0];
    return new SupplierResponseItemDepot();
  }

  getOtherDepots(item: SupplierResponseItem): SupplierResponseItemDepot[] {
    if (item?.Depots?.length > 1) return item.Depots.slice(1);
    return null;
  }

  isDateOk(date: Date | null): boolean {
    if (date && date.getFullYear() < 2999) return true;
    return false;
  }

}
